export const THIRD_PARTY = 'third-party';
export const MOTOR = 'motor';
export const TRAVEL = 'travel';
export const ELECTRONIC_EQUIPMENTS = 'electronic-equipment';
export const SPECIAL_EQUIPMENTS = 'electronics-saman';
export const ELEVATOR = 'elevator';
export const FIRE = 'fire';
export const EARTHQUAKE = 'earthquake';
export const CAR_BODY = 'car-body';
export const HEALTH = 'health';
export const HEALTH_GROUP = 'health-group';
export const HEALTH_ONLINE = 'health-online';
export const HEALTH_FOREIGNERS = 'health-foreigners';
export const MEDICAL_LIABILITY = 'medical-liability';
export const TRAVEL_PLUS = 'travel-plus';
export const MANUAL = 'manual';
export const PILGRIMAGE = 'pilgrimage';
export const PILGRIMAGE_ONLINE = 'pilgrimage-online';
export const PERSONAL_ACCIDENT = 'personal-accident';
export const SPORTS = 'sports';
export const BUSINESS_FIRE = 'business-fire';
export const WAR = 'war';